
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { ReCaptchaWrapper } from "./ReCaptchaWrapper";
import { EarlyAccessFormFields } from "./EarlyAccessFormFields";
import { EarlyAccessBenefits } from "./EarlyAccessBenefits";
import { RecaptchaDisclaimer } from "./RecaptchaDisclaimer";
import { useEarlyAccessForm } from "./hooks/useEarlyAccessForm";

interface EarlyAccessFormProps {
  onBack: () => void;
}

export const EarlyAccessForm = ({ onBack }: EarlyAccessFormProps) => {
  const {
    formData,
    isLoading,
    updateFormField,
    handleAccountTypeSelect,
    handleSubmit
  } = useEarlyAccessForm();

  return (
    <ReCaptchaWrapper action="early_access">
      {(token) => (
        <Card className="w-full max-w-md mx-auto bg-gray-800/50 border-gray-700 mb-16 sm:mb-0 prevent-scroll-freeze">
          <CardHeader>
            <div className="flex items-center justify-between">
              <button
                onClick={onBack}
                className="text-blue-400 hover:text-blue-300 flex items-center gap-1"
              >
                <ArrowLeft className="h-4 w-4" />
                Back to Landing
              </button>
            </div>
            <div className="mt-8 space-y-2">
              <CardTitle className="text-2xl text-white">Request Early Access</CardTitle>
              <CardDescription className="text-gray-400">
                Join our exclusive early access program
              </CardDescription>
            </div>
          </CardHeader>
          
          <CardContent>
            <form onSubmit={(e) => handleSubmit(e, token)} className="space-y-4">
              <EarlyAccessFormFields 
                name={formData.name}
                email={formData.email}
                company={formData.company}
                referralSource={formData.referralSource}
                accountType={formData.accountType}
                userRole={formData.userRole}          // Add this new prop
                implementationTimeline={formData.implementationTimeline}  // Add this new prop
                onUpdateField={updateFormField}
                onAccountTypeChange={handleAccountTypeSelect}
              />

              <EarlyAccessBenefits />
              <RecaptchaDisclaimer />

              <Button 
                type="submit" 
                className="w-full bg-blue-600 hover:bg-blue-700 text-white mt-6"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit Request"}
              </Button>
            </form>
          </CardContent>
          
          <CardFooter className="text-xs text-center text-gray-400">
            By submitting this form, you agree to be contacted about our early access program.
          </CardFooter>
        </Card>
      )}
    </ReCaptchaWrapper>
  );
};
